import new1 from 'src/assets/images/new1.jpg'
import new2 from 'src/assets/images/new2.jpg'
import new3 from 'src/assets/images/new3.jpg'
import news1 from 'src/assets/images/news_1.png'
import news2 from 'src/assets/images/news_2.png'
import news3 from 'src/assets/images/news_3.png'

export type NewsArticle = {
   id: number
   slug: string
   title: string
   description: string
   image: string
   category: string
   readTime: string
   publishedAt: string
   updatedAt: string
   keywords: string[]
   intro: string
   sections: {
      heading: string
      body: string[]
   }[]
   takeaway: string
}

export const newsArticles: NewsArticle[] = [
   {
      id: 1,
      slug: 'kinh-nghiem-dat-xe-ghep-thanh-hoa-ha-noi',
      title: 'Kinh nghiệm đặt xe ghép Thanh Hóa Hà Nội cho chuyến đi đỡ mệt hơn',
      description:
         'Cách đặt xe ghép Thanh Hóa Hà Nội dễ hiểu: chọn giờ đi, điểm đón trả, hỏi trước giá và chuẩn bị hành lý để chuyến đi gọn nhẹ hơn.',
      image: news1,
      category: 'Kinh nghiệm đi xe',
      readTime: '5 phút đọc',
      publishedAt: '2026-07-11',
      updatedAt: '2026-07-11',
      keywords: ['xe ghép Thanh Hóa Hà Nội', 'đặt xe ghép', 'xe ghép Hà Nội Thanh Hóa', 'đón trả tận nơi'],
      intro:
         'Đi Thanh Hóa - Hà Nội nghe thì quen, nhưng mỗi lần đặt xe vẫn có vài thứ nên hỏi kỹ từ đầu: giờ chạy, điểm đón, điểm trả, giá ghế và số hành lý mang theo. Chuẩn bị trước mấy ý nhỏ này giúp chuyến đi nhẹ đầu hơn hẳn.',
      sections: [
         {
            heading: 'Chốt rõ giờ đi và điểm đón trước khi lên xe',
            body: [
               'Tuyến Thanh Hóa - Hà Nội thường có nhiều khung giờ trong ngày, nhưng không phải giờ nào cũng hợp với lịch cá nhân. Nếu cần ra bến xe, sân bay, bệnh viện hoặc đi làm đúng giờ, bạn nên nói rõ thời gian cần có mặt ở Hà Nội.',
               'Với xe ghép, điểm đón trả linh hoạt là lợi thế lớn. Tuy vậy, càng chốt sớm địa chỉ cụ thể thì tài xế càng dễ sắp tuyến, hạn chế vòng xe quá nhiều.'
            ]
         },
         {
            heading: 'Hỏi giá ghế và phụ phí nếu có',
            body: [
               'Trước khi xác nhận chuyến, hãy hỏi giá ghế cho đúng tuyến bạn đi: Thanh Hóa đi Hà Nội, Hà Nội đi Thanh Hóa, hoặc các điểm xa hơn như Sầm Sơn, Bỉm Sơn, Nga Sơn, Hậu Lộc.',
               'Nếu có hành lý cồng kềnh hoặc gửi thêm đồ, bạn nên báo trước. Việc này không chỉ lịch sự mà còn giúp xe chuẩn bị khoang chứa phù hợp.'
            ]
         },
         {
            heading: 'Đi xe ghép nên mang đồ gọn',
            body: [
               'Một balo, một vali nhỏ hoặc túi đồ cá nhân sẽ dễ sắp xếp hơn nhiều. Nếu đi cùng người lớn tuổi hoặc trẻ nhỏ, bạn nên chọn giờ đi thoáng, tránh quá sát lịch hẹn quan trọng.',
               'Nước uống, áo khoác mỏng và tai nghe là combo khá ổn cho chuyến đường dài. Không cần chuẩn bị cầu kỳ, chỉ cần đủ dùng.'
            ]
         }
      ],
      takeaway:
         'Đặt xe ghép Thanh Hóa Hà Nội không khó. Quan trọng là nói rõ nhu cầu thật của mình từ đầu để chuyến đi đúng giờ, đúng điểm và thoải mái hơn.'
   },
   {
      id: 2,
      slug: 'ha-noi-thanh-hoa-di-xe-ghep-hay-xe-khach',
      title: 'Hà Nội Thanh Hóa nên đi xe ghép hay xe khách?',
      description:
         'So sánh xe ghép và xe khách tuyến Hà Nội Thanh Hóa theo nhu cầu thực tế: đi một mình, đi gia đình, mang hành lý, cần đón trả tận nơi.',
      image: news2,
      category: 'So sánh lựa chọn',
      readTime: '4 phút đọc',
      publishedAt: '2026-07-11',
      updatedAt: '2026-07-11',
      keywords: ['Hà Nội Thanh Hóa', 'xe ghép Hà Nội Thanh Hóa', 'xe khách Thanh Hóa Hà Nội', 'bao xe riêng'],
      intro:
         'Không có lựa chọn nào đúng cho tất cả mọi người. Xe khách hợp khi bạn quen ra bến, ít đồ và muốn tối ưu chi phí. Xe ghép hợp khi bạn cần đón trả gần nhà, đi cùng gia đình hoặc muốn chuyến đi riêng tư hơn một chút.',
      sections: [
         {
            heading: 'Xe khách hợp với lịch trình đơn giản',
            body: [
               'Nếu bạn ở gần bến, hành lý ít và không ngại di chuyển thêm bằng taxi hoặc xe ôm, xe khách vẫn là lựa chọn quen thuộc. Đi xe khách cũng dễ tìm chuyến vào các khung giờ phổ biến.',
               'Điểm trừ là bạn thường phải tự ra điểm đón cố định. Với người mang nhiều đồ, đi cùng trẻ nhỏ hoặc người lớn tuổi, phần di chuyển trước và sau chuyến có thể khá mệt.'
            ]
         },
         {
            heading: 'Xe ghép hợp khi cần đón trả linh hoạt',
            body: [
               'Xe ghép Thanh Hóa Hà Nội có lợi thế ở điểm đón trả. Bạn có thể hẹn tài xế ở khu vực thuận tiện hơn, nhất là khi đi từ các quận nội thành Hà Nội hoặc về các huyện ở Thanh Hóa.',
               'Không gian xe nhỏ hơn, ít khách hơn, nên cảm giác chuyến đi thường nhẹ nhàng hơn. Với người dễ say xe, việc chọn xe đời mới, sạch và ít mùi cũng là điểm đáng cân nhắc.'
            ]
         },
         {
            heading: 'Khi nào nên bao xe riêng?',
            body: [
               'Nếu đi nhóm 3-5 người, có nhiều hành lý, cần đi gấp hoặc muốn chủ động giờ giấc, bao xe riêng sẽ hợp lý hơn. Chi phí chia theo nhóm đôi khi không chênh quá nhiều so với mua từng ghế.',
               'Bao xe riêng cũng phù hợp cho chuyến đi công tác, thăm người thân, đưa đón sân bay hoặc lịch trình có nhiều điểm dừng.'
            ]
         }
      ],
      takeaway:
         'Nếu ưu tiên tiện, riêng tư và đón trả linh hoạt, xe ghép hoặc bao xe là lựa chọn đáng thử cho tuyến Hà Nội - Thanh Hóa.'
   },
   {
      id: 3,
      slug: 'goi-y-diem-den-ha-noi-khi-di-tu-thanh-hoa',
      title: 'Gợi ý điểm đến ở Hà Nội khi đi từ Thanh Hóa lên chơi cuối tuần',
      description:
         'Một vài điểm đến Hà Nội dễ đi cho khách từ Thanh Hóa: Lăng Bác, phố cổ, Hồ Gươm, Mỹ Đình và các khu ăn uống quen thuộc.',
      image: new1,
      category: 'Điểm đến',
      readTime: '6 phút đọc',
      publishedAt: '2026-07-11',
      updatedAt: '2026-07-11',
      keywords: ['đi Hà Nội từ Thanh Hóa', 'xe Thanh Hóa Hà Nội', 'địa điểm Hà Nội', 'đi chơi Hà Nội'],
      intro:
         'Lên Hà Nội cuối tuần không nhất thiết phải lên lịch dày đặc. Chọn vài điểm dễ đi, ăn một món ngon, dạo một vòng rồi về cũng đủ có cảm giác đổi gió.',
      sections: [
         {
            heading: 'Lăng Bác và khu Ba Đình',
            body: [
               'Khu Ba Đình là lựa chọn kinh điển nhưng chưa bao giờ lỗi thời. Nếu đi cùng gia đình, đặc biệt là trẻ nhỏ, đây là điểm đến vừa có ý nghĩa lịch sử vừa dễ kết hợp tham quan xung quanh.',
               'Bạn nên đi sớm để thời tiết dễ chịu hơn. Nếu đặt xe ghép từ Thanh Hóa lên Hà Nội, hãy báo trước điểm trả gần khu Ba Đình để tài xế sắp tuyến phù hợp.'
            ]
         },
         {
            heading: 'Hồ Gươm, phố cổ và một buổi đi bộ nhẹ',
            body: [
               'Hồ Gươm hợp với kiểu đi chơi không cần quá nhiều kế hoạch. Đi bộ một vòng, ghé cà phê, ăn nhẹ rồi qua phố cổ là đủ trọn một buổi.',
               'Cuối tuần khu vực này đông, nên nếu có hẹn xe về Thanh Hóa trong ngày, bạn nên căn giờ dư ra một chút để tránh cập rập.'
            ]
         },
         {
            heading: 'Mỹ Đình cho lịch sự kiện, sân vận động và xe về tỉnh',
            body: [
               'Khu Mỹ Đình thường tiện nếu bạn đi xem bóng đá, concert hoặc cần trung chuyển. Đây cũng là khu dễ hẹn điểm đón trả khi đi Hà Nội - Thanh Hóa.',
               'Nếu đi sự kiện tối, hãy đặt xe chiều về sớm. Sau sự kiện, lượng người gọi xe thường tăng, đường đông và dễ mất thời gian.'
            ]
         }
      ],
      takeaway:
         'Đi Hà Nội từ Thanh Hóa vui nhất khi lịch trình vừa đủ. Chọn điểm đến rõ, hẹn xe rõ, còn lại cứ thong thả tận hưởng.'
   },
   {
      id: 4,
      slug: 'gui-hang-thanh-hoa-ha-noi-trong-ngay-can-luu-y-gi',
      title: 'Gửi hàng Thanh Hóa Hà Nội trong ngày cần lưu ý gì?',
      description:
         'Kinh nghiệm gửi hàng Thanh Hóa Hà Nội trong ngày: đóng gói, ghi thông tin người nhận, báo trước kích thước và chọn khung giờ phù hợp.',
      image: news3,
      category: 'Gửi hàng',
      readTime: '4 phút đọc',
      publishedAt: '2026-07-11',
      updatedAt: '2026-07-11',
      keywords: ['gửi hàng Thanh Hóa Hà Nội', 'gửi đồ Hà Nội Thanh Hóa', 'xe ghép gửi hàng', 'giao hàng trong ngày'],
      intro:
         'Gửi đồ theo xe tuyến Thanh Hóa - Hà Nội khá tiện với những món cần đi nhanh trong ngày. Nhưng để đồ đến nơi gọn gàng, bạn nên chuẩn bị thông tin và đóng gói tử tế ngay từ đầu.',
      sections: [
         {
            heading: 'Ghi rõ người gửi, người nhận và số điện thoại',
            body: [
               'Một tờ giấy nhỏ dán ngoài kiện hàng có thể cứu rất nhiều thời gian. Nên ghi tên người nhận, số điện thoại, địa chỉ nhận và ghi chú nếu cần giao ở một điểm cụ thể.',
               'Nếu đồ cần nhận gấp, bạn nên báo trước để tài xế chủ động liên hệ khi gần tới điểm trả.'
            ]
         },
         {
            heading: 'Đóng gói theo tính chất món đồ',
            body: [
               'Đồ dễ vỡ nên có lớp chống sốc. Đồ ăn nên đóng kín, tránh chảy nước hoặc ám mùi lên hành lý khác. Giấy tờ, hồ sơ nên bỏ trong túi chống nước.',
               'Với kiện lớn, hãy báo kích thước trước. Xe ghép còn chở khách, nên khoang chứa cần được sắp xếp hợp lý.'
            ]
         },
         {
            heading: 'Chọn khung giờ gửi phù hợp',
            body: [
               'Nếu người nhận chỉ rảnh buổi tối hoặc giờ hành chính, bạn nên chọn chuyến tương ứng. Việc này đơn giản nhưng giúp tránh cảnh xe đến nơi mà người nhận chưa sẵn sàng.',
               'Gửi hàng trong ngày tiện nhất khi cả hai đầu đều chủ động nghe máy.'
            ]
         }
      ],
      takeaway:
         'Gửi hàng Thanh Hóa Hà Nội bằng xe ghép sẽ mượt hơn khi thông tin rõ, đồ đóng gói gọn và hai bên thống nhất giờ nhận.'
   },
   {
      id: 5,
      slug: 'lich-trinh-thanh-hoa-ha-noi-cho-nguoi-di-cong-tac',
      title: 'Lịch trình Thanh Hóa Hà Nội cho người đi công tác trong ngày',
      description:
         'Gợi ý cách đặt xe Thanh Hóa Hà Nội cho người đi công tác: chọn giờ xuất phát, điểm trả gần nơi hẹn và phương án về trong ngày.',
      image: new3,
      category: 'Công tác',
      readTime: '5 phút đọc',
      publishedAt: '2026-07-11',
      updatedAt: '2026-07-11',
      keywords: ['xe Thanh Hóa Hà Nội công tác', 'đặt xe đi Hà Nội', 'bao xe Thanh Hóa Hà Nội', 'xe ghép công tác'],
      intro:
         'Đi công tác trong ngày cần nhất là đúng giờ và ít phát sinh. Một chuyến xe ổn không chỉ đưa bạn tới nơi, mà còn giúp bạn còn sức để làm việc.',
      sections: [
         {
            heading: 'Đừng đặt giờ quá sát lịch họp',
            body: [
               'Đường Thanh Hóa - Hà Nội có thể thay đổi theo thời tiết, giờ cao điểm và điểm trả. Nếu có lịch họp quan trọng, hãy đặt xe sớm hơn nhu cầu thực tế một khoảng an toàn.',
               'Bạn cũng nên gửi địa chỉ điểm đến cụ thể, ví dụ tòa nhà, cổng bệnh viện, văn phòng hoặc khách sạn để tài xế tính đường thuận hơn.'
            ]
         },
         {
            heading: 'Đi một mình có thể chọn xe ghép, đi nhóm nên cân nhắc bao xe',
            body: [
               'Nếu chỉ đi một người và lịch không quá gấp, xe ghép là lựa chọn tiết kiệm. Nếu đi nhóm, mang tài liệu, thiết bị hoặc cần ghé nhiều điểm, bao xe riêng sẽ chủ động hơn.',
               'Với nhóm công tác, chi phí chia ra thường dễ chịu hơn, trong khi cả đoàn giữ được cùng một lịch trình.'
            ]
         },
         {
            heading: 'Chốt luôn chiều về nếu cần về trong ngày',
            body: [
               'Nhiều người chỉ chăm chăm đặt chiều đi rồi tới lúc xong việc mới tìm xe về. Cách này hơi rủi ro, nhất là khi kết thúc muộn.',
               'Nếu biết khoảng giờ về, hãy đặt trước hoặc ít nhất báo nhu cầu từ đầu. Tài xế sẽ tư vấn khung giờ hợp lý hơn.'
            ]
         }
      ],
      takeaway:
         'Đi công tác Thanh Hóa - Hà Nội nên ưu tiên sự chủ động. Đặt xe sớm, nói rõ điểm đến và chuẩn bị phương án về giúp cả ngày gọn hơn.'
   },
   {
      id: 6,
      slug: 'di-sam-son-ha-noi-bang-xe-ghep-co-tien-khong',
      title: 'Đi Sầm Sơn Hà Nội bằng xe ghép có tiện không?',
      description:
         'Xe ghép Sầm Sơn Hà Nội phù hợp cho khách du lịch, người về quê hoặc gia đình cần đón trả linh hoạt sau chuyến biển.',
      image: new2,
      category: 'Tuyến nổi bật',
      readTime: '4 phút đọc',
      publishedAt: '2026-07-11',
      updatedAt: '2026-07-11',
      keywords: ['xe ghép Sầm Sơn Hà Nội', 'Sầm Sơn Hà Nội', 'xe Thanh Hóa Hà Nội', 'đặt xe Sầm Sơn'],
      intro:
         'Sầm Sơn là điểm đi lại khá nhiều, nhất là mùa du lịch. Sau vài ngày đi biển, điều ai cũng muốn là một chuyến xe về Hà Nội gọn gàng, không phải kéo vali đổi nhiều chặng.',
      sections: [
         {
            heading: 'Xe ghép hợp khi bạn có hành lý du lịch',
            body: [
               'Đi Sầm Sơn thường có vali, túi đồ biển, quà mang về. Xe ghép có điểm tiện là có thể hẹn đón gần khách sạn hoặc khu vực thuận đường, đỡ phải di chuyển ra bến.',
               'Nếu đoàn đông, bạn nên báo số người và số hành lý từ đầu để được tư vấn xe phù hợp.'
            ]
         },
         {
            heading: 'Nên đặt trước vào cuối tuần',
            body: [
               'Cuối tuần và mùa cao điểm, nhu cầu Sầm Sơn - Hà Nội tăng rõ. Đặt sát giờ đôi khi vẫn có xe, nhưng lựa chọn khung giờ đẹp sẽ ít hơn.',
               'Nếu có trẻ nhỏ hoặc người lớn tuổi, chọn giờ mát và tránh quá khuya sẽ dễ chịu hơn.'
            ]
         },
         {
            heading: 'Chốt điểm trả ở Hà Nội càng rõ càng tốt',
            body: [
               'Hà Nội rộng, mỗi điểm trả có thể khiến lịch trình khác nhau khá nhiều. Bạn nên gửi quận, phố hoặc địa chỉ gần nhất để tài xế sắp tuyến.',
               'Nếu cần ra sân bay, bến xe hoặc ga tàu sau khi về Hà Nội, hãy nói luôn để tránh trễ chuyến tiếp theo.'
            ]
         }
      ],
      takeaway:
         'Xe ghép Sầm Sơn Hà Nội tiện nhất khi bạn đặt trước, báo rõ hành lý và chọn điểm đón trả thực tế với lịch của mình.'
   }
]

export const getNewsArticleBySlug = (slug: string) => newsArticles.find((article) => article.slug === slug)
